import {DATASET_DIMENSIONS_GROUPS_STATE_NAME, DataSetDimensionsGroupsState} from './dataSetDimensionsGroups';
import {createFeatureSelector, createSelector, MemoizedSelector} from '@ngrx/store';
import {Serializers} from '../../interfaces/serializer';
import {DataSetDimensionsGroup} from '../../interfaces/dimensions';
import {DatasetDimensionsGroupComponentObjects} from '../../classes/dataset-dimensions-group-component-object';

export const selectDataSetDimensionsGroupsState: MemoizedSelector<object, DataSetDimensionsGroupsState> = createFeatureSelector(DATASET_DIMENSIONS_GROUPS_STATE_NAME);

export const selectDataSetDimensionsGroups: MemoizedSelector<object, Serializers<DataSetDimensionsGroup>> = createSelector(
  selectDataSetDimensionsGroupsState,
  (state: DataSetDimensionsGroupsState): Serializers<DataSetDimensionsGroup> => state.serialized
);

export const selectDataSetDimensionsGroupComponentObjects: MemoizedSelector<object, DatasetDimensionsGroupComponentObjects> = createSelector(
  selectDataSetDimensionsGroupsState,
  (state: DataSetDimensionsGroupsState): DatasetDimensionsGroupComponentObjects => state.componentObjects
);

export const selectDataSetDimensionsGroupsLoading: MemoizedSelector<object, boolean> = createSelector(
  selectDataSetDimensionsGroupsState,
  (state: DataSetDimensionsGroupsState): boolean => state.loading
);

export const selectDataSetDimensionsGroupsLoaded: MemoizedSelector<object, boolean> = createSelector(
  selectDataSetDimensionsGroupsState,
  (state: DataSetDimensionsGroupsState): boolean => state.loaded
);
